import { defineComponent } from "vue";
import Utils from "../../utils/Utils";
import InvoiceLayout from "../../layouts/InvoiceLayout";
import UsageForm, { UsageInfo } from "../../components/UsageForm";

export default defineComponent({
    components: {
        InvoiceLayout,
        UsageForm,
    },

    template: `
        <InvoiceLayout class="StepCalc">
            <h2 class="StepCalc__title">Zielona energia<br>w Twoim domu</h2>

            <div class="StepCalc__body contentbox">
                <h2>Kalkulator oferty</h2>

                <UsageForm
                    :initialusage="getInitialUsage()"
                    @usage="onNext"
                />
            </div>
        </InvoiceLayout>
    `,

    emits: [
        'next',
    ],

    data() {
        return {
        };
    },

    methods: {
        getInitialUsage() {
            const urlParams = new URLSearchParams(window.location.search);

            if (urlParams.get("kwh")) {
                return parseInt(urlParams.get("kwh"));
            } else {
                return 1500;
            }
        },

        async onNext(info: UsageInfo) {
            await Utils.setCart('calc', {
                usage: info.usage,
                size: info.size,
                type: info.type,
            });

            this.$emit('next', info);
        },
    },
});
